import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const
  Contacto = lazy(() => import('../../../views/Contacto/index'))


const Index = (props: any) => {
  return (
    <Switch>
      <Route path={`${props.match.path}`} component={Contacto} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
